export const AsyncActionTypes = {
  PUBLICATION: 'publication',
  MULTI_LANG: 'multilang',
  ALL: 'actions'
};